import { render, staticRenderFns } from "./ProjectBalance.vue?vue&type=template&id=55fc9a0b&"
import script from "./ProjectBalance.vue?vue&type=script&lang=js&"
export * from "./ProjectBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports